"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UrlUtils = _interopRequireDefault(require("@icare/core/lib/utils/UrlUtils"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _ContentHeader = _interopRequireDefault(require("@icare/components/lib/ContentHeader"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _IdentityService = _interopRequireDefault(require("../services/IdentityService"));

var _IdentityUtils = _interopRequireDefault(require("../utils/IdentityUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var challengeConfig = {
  id: "resetPassword",
  sections: [{
    id: "questionForm",
    fields: [{
      id: "Answer",
      type: "text",
      required: true,
      requiredMessage: "Please enter your secret answer"
    }]
  }, {
    id: "createPasswordForm",
    fields: [{
      id: "NewPassword",
      type: "password",
      required: true,
      requiredMessage: "Please enter your new password",
      validators: [{
        type: "isPassword",
        data: {
          message: "Your password doesn\u2019t meet the requirements above. Please try again."
        }
      }, {
        type: "isLength",
        data: {
          message: "Your new password has too many characters, please ensure your new password is less than {max} characters",
          options: {
            max: 100
          }
        }
      }]
    }, {
      id: "VerifyPassword",
      type: "password",
      required: true,
      requiredMessage: "Please re-type your new password",
      validators: [{
        type: "isMatch",
        data: {
          sectionId: "createPasswordForm",
          fieldId: "NewPassword",
          message: "Sorry, your passwords do not match. Please try again."
        }
      }]
    }]
  }]
};
var viewState = {
  SECRET_CHALLENGE: 0,
  RESET_PASSWORD: 1
};
var errorCodes = {
  PASSWORD_RESET_FAILED: 'PASSWORD_RESET_FAILED' // is thrown when we get E0000011 or E0000017 from Okta

};

var ResetPasswordForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ResetPasswordForm, _React$Component);

  var _super = _createSuper(ResetPasswordForm);

  //region Properties
  //endregion
  //region Lifecycle
  function ResetPasswordForm(props) {
    var _this;

    _classCallCheck(this, ResetPasswordForm);

    _this = _super.call(this, props);
    var config = props.onInitilise(challengeConfig); //check overrides for messages before initializing the form

    if (_this.props.requiredMessageNewPassword) {
      var fieldNewPassword = config.sections.find(function (section) {
        return section.id === 'createPasswordForm';
      }).fields.find(function (field) {
        return field.id === 'NewPassword';
      });

      if (fieldNewPassword) {
        fieldNewPassword.requiredMessage = _this.props.requiredMessageNewPassword;
      }
    }

    if (_this.props.requiredMessageVerifyPassword) {
      var fieldRetypePassword = config.sections.find(function (section) {
        return section.id === 'createPasswordForm';
      }).fields.find(function (field) {
        return field.id === 'VerifyPassword';
      });

      if (fieldRetypePassword) {
        fieldRetypePassword.requiredMessage = _this.props.requiredMessageVerifyPassword;
      }
    }

    if (_this.props.requiredMessageSecurityAnswer) {
      var securityAnswer = config.sections.find(function (section) {
        return section.id === 'questionForm';
      }).fields.find(function (field) {
        return field.id === 'Answer';
      });

      if (securityAnswer) {
        securityAnswer.requiredMessage = _this.props.requiredMessageSecurityAnswer;
      }
    }

    _this.state = {
      form: _Form.default.initialiseFromConfig(config),
      stateToken: null,
      question: null,
      viewState: viewState.SECRET_CHALLENGE,
      message: null,
      isBusy: true,
      successfulReset: false
    };
    _this._service = new _IdentityService.default(props.apiBaseUrl);
    _this._handleSecurityQuestionFormSubmit = _this._handleSecurityQuestionFormSubmit.bind(_assertThisInitialized(_this));
    _this._handleResetFormSubmit = _this._handleResetFormSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ResetPasswordForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Get the token from the url and load the security question
      var token = _UrlUtils.default.getParam(window.location, 'recoveryToken');

      if (token) {
        this._loadSecurityQuestion(token);
      } else {
        console.error('Missing recovery token in url');
        this.setState({
          message: _IdentityUtils.default.getErrorDetails(),
          isBusy: false
        });
      }
    } //endregion
    //region Common

  }, {
    key: "_renderMessage",
    value: function _renderMessage() {
      var message = this.state.message;

      if (!message) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Message.default, {
        title: message.title,
        type: message.type
      }, message.body);
    } //endregion
    //region Security Question Form Methods

  }, {
    key: "_loadSecurityQuestion",
    value: function () {
      var _loadSecurityQuestion2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
        var _yield$this$_service$, stateToken, question;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this._service.retrieveQuestion(token);

              case 3:
                _yield$this$_service$ = _context.sent;
                stateToken = _yield$this$_service$.stateToken;
                question = _yield$this$_service$.question;
                this.setState({
                  isBusy: false,
                  stateToken: stateToken,
                  question: question,
                  message: null
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                if (_context.t0.name === 'APIError') {
                  if (_context.t0.innerErrors.find(function (e) {
                    return e.code === errorCodes.PASSWORD_RESET_FAILED;
                  })) {
                    this.props.onTokenExpired();
                  } else {
                    this.setState({
                      isBusy: false,
                      message: _IdentityUtils.default.getErrorDetails(_context.t0.innerErrors)
                    });
                  }
                } else {
                  console.error(_context.t0);
                  this.setState({
                    isBusy: false,
                    message: _IdentityUtils.default.getErrorDetails()
                  });
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function _loadSecurityQuestion(_x) {
        return _loadSecurityQuestion2.apply(this, arguments);
      }

      return _loadSecurityQuestion;
    }()
  }, {
    key: "_handleSecurityQuestionFormSubmit",
    value: function () {
      var _handleSecurityQuestionFormSubmit2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
        var answer, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                answer = values.questionForm__Answer;
                _context2.prev = 1;
                this.setState({
                  isBusy: true,
                  message: null
                }); // eslint-disable-next-line react/no-access-state-in-setstate

                _context2.next = 5;
                return this._service.verifyAnswer(answer, this.state.stateToken);

              case 5:
                result = _context2.sent;
                this.setState({
                  isBusy: false,
                  stateToken: result.stateToken,
                  viewState: viewState.RESET_PASSWORD
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  isBusy: false,
                  message: _IdentityUtils.default.getErrorDetails(_context2.t0.innerErrors)
                });

                if (_context2.t0.name !== 'APIError') {
                  console.error(_context2.t0);
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9]]);
      }));

      function _handleSecurityQuestionFormSubmit(_x2) {
        return _handleSecurityQuestionFormSubmit2.apply(this, arguments);
      }

      return _handleSecurityQuestionFormSubmit;
    }()
  }, {
    key: "_renderSecurityQuestionForm",
    value: function _renderSecurityQuestionForm() {
      var _this$state = this.state,
          form = _this$state.form,
          question = _this$state.question,
          message = _this$state.message,
          isBusy = _this$state.isBusy;

      if (!question) {
        if (isBusy) {
          return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
            active: true
          });
        }

        return message ? this._renderMessage() : null;
      }

      return [/*#__PURE__*/_react.default.createElement(_ContentHeader.default, {
        key: "questionHeader",
        heading: this.props.questionHeading,
        subHeading: question
      }), /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: isBusy,
        key: "questionForm"
      }, /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleSecurityQuestionFormSubmit
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "Answer",
        sectionId: "questionForm"
      }), message ? this._renderMessage() : /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form,
        validateAfterSubmit: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-holder"
      }, this.props.additionalQuestionFormButtons, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: this.state.isBusy
      }, this.props.submitAnswerBtnText))))];
    } //endregion
    //region Reset Form Methods

  }, {
    key: "_handleResetFormSubmit",
    value: function () {
      var _handleResetFormSubmit2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(values) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.setState({
                  isBusy: true,
                  message: null
                });
                _context3.next = 4;
                return this._service.changePasswordWithToken(this.state.stateToken, values.createPasswordForm__VerifyPassword);

              case 4:
                this.setState({
                  isBusy: false,
                  successfulReset: true,
                  message: {
                    type: _Message.default.type.SUCCESS,
                    title: this.props.confirmationTitle,
                    body: /*#__PURE__*/_react.default.createElement("div", {
                      dangerouslySetInnerHTML: {
                        __html: this.props.confirmationRichText
                      }
                    })
                  },
                  viewState: viewState.RESET_PASSWORD
                }, function () {
                  _this2.state.form.fields.get('createPasswordForm__NewPassword').set('disabled', true);

                  _this2.state.form.fields.get('createPasswordForm__VerifyPassword').set('disabled', true);
                });
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.name === 'APIError') {
                  if (_context3.t0.innerErrors.find(function (e) {
                    return e.code === errorCodes.PASSWORD_RESET_FAILED;
                  })) {
                    this.props.onTokenExpired();
                  } else {
                    this.setState({
                      isBusy: false,
                      message: _IdentityUtils.default.getErrorDetails(_context3.t0.innerErrors)
                    });
                  }
                } else {
                  console.error(_context3.t0);
                  this.setState({
                    isBusy: false,
                    message: _IdentityUtils.default.getErrorDetails()
                  });
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function _handleResetFormSubmit(_x3) {
        return _handleResetFormSubmit2.apply(this, arguments);
      }

      return _handleResetFormSubmit;
    }()
  }, {
    key: "_renderResetForm",
    value: function _renderResetForm() {
      var _this$state2 = this.state,
          form = _this$state2.form,
          message = _this$state2.message,
          isBusy = _this$state2.isBusy,
          successfulReset = _this$state2.successfulReset;
      return [/*#__PURE__*/_react.default.createElement("h1", {
        key: "header"
      }, this.props.resetHeading), /*#__PURE__*/_react.default.createElement("div", {
        key: "subHeader",
        className: "module-spacing",
        dangerouslySetInnerHTML: {
          __html: this.props.passwordRulesRichText
        }
      }), /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        key: "resetForm",
        active: isBusy
      }, /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleResetFormSubmit
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "NewPassword",
        sectionId: "createPasswordForm",
        disabled: successfulReset
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "VerifyPassword",
        sectionId: "createPasswordForm",
        disabled: successfulReset
      }), message ? this._renderMessage() : /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form,
        validateAfterSubmit: true
      }), !successfulReset && /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-holder"
      }, this.props.additionalResetFormButtons, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: this.state.isBusy
      }, this.props.submitResetBtnText))))];
    } //endregion

  }, {
    key: "render",
    value: function render() {
      switch (this.state.viewState) {
        case viewState.RESET_PASSWORD:
          return this._renderResetForm();

        default:
          return this._renderSecurityQuestionForm();
      }
    }
  }]);

  return ResetPasswordForm;
}(_react.default.Component);

_defineProperty(ResetPasswordForm, "propTypes", {
  onInitilise: _propTypes.default.func,
  onTokenExpired: _propTypes.default.func,
  apiBaseUrl: _propTypes.default.string.isRequired,
  questionHeading: _propTypes.default.string,
  submitAnswerBtnText: _propTypes.default.string,
  additionalQuestionFormButtons: _propTypes.default.node,
  resetHeading: _propTypes.default.string,
  submitResetBtnText: _propTypes.default.string,
  passwordRulesRichText: _propTypes.default.string,
  confirmationRichText: _propTypes.default.string,
  confirmationTitle: _propTypes.default.string,
  additionalResetFormButtons: _propTypes.default.node,
  requiredMessageSecurityAnswer: _propTypes.default.string,
  requiredMessageNewPassword: _propTypes.default.string,
  requiredMessageVerifyPassword: _propTypes.default.string
});

_defineProperty(ResetPasswordForm, "defaultProps", {
  onInitilise: function onInitilise(config) {
    return config;
  },
  onTokenExpired: function onTokenExpired() {},
  questionHeading: 'Validate Secret Question',
  resetHeading: 'Reset Password',
  submitAnswerBtnText: 'Submit',
  submitResetBtnText: 'Submit',
  passwordRulesRichText: null,
  confirmationRichText: null,
  confirmationTitle: 'Your password has successfully been changed.',
  additionalQuestionFormButtons: null,
  additionalResetFormButtons: null,
  requiredMessageSecurityAnswer: '',
  requiredMessageNewPassword: '',
  requiredMessageVerifyPassword: ''
});

var _default = ResetPasswordForm;
exports.default = _default;
//# sourceMappingURL=ResetPassword.js.map